var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBasicSemenAnalysis(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6616 21C16.9083 21 21.1616 16.7467 21.1616 11.5C21.1616 6.25329 16.9083 2 11.6616 2C6.41492 2 2.16162 6.25329 2.16162 11.5C2.16162 16.7467 6.41492 21 11.6616 21Z",
    stroke: "#D3B474",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1616 22L20.1616 20",
    stroke: "#D3B474",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.93424 12.1915C8.11119 12.1915 6.0748 9.3406 7.29664 8.17695C8.34392 7.18785 10.6518 8.6812 11.0979 10.4267C11.35 11.4158 10.8652 12.1915 9.93424 12.1915ZM8.14998 8.64241C7.06391 8.64241 8.0918 10.8921 9.58515 11.3576C10.7876 11.7067 10.4967 10.3297 9.64333 9.45697C9.13908 8.91393 8.53786 8.64241 8.14998 8.64241Z",
    fill: "#D3B474",
    stroke: "#D3B474",
    strokeWidth: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0133 15.1393C16.897 15.1393 16.8 15.0811 16.7224 14.9842C15.1903 13.1999 11.7963 14.0145 10.1866 11.8423C9.89567 11.435 10.5163 10.9696 10.8072 11.3769C12.1842 13.2387 15.5976 12.4435 17.3042 14.4993C17.5176 14.7514 17.343 15.1393 17.0133 15.1393Z",
    fill: "#D3B474",
    stroke: "#D3B474",
    strokeWidth: 0.3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasicSemenAnalysis);
export default __webpack_public_path__ + "static/media/BasicSemenAnalysis.2d3803850f4cfef101e8f23d18f29a6e.svg";
export { ForwardRef as ReactComponent };